<span class="group inline-flex items-center">
    <span class="font-headline {{ white() ? 'text-white' : 'text-grey-400' }} text-16 leading-20 group-hover:underline">
        <ng-content />
    </span>
    <i class="icon-share ml-8 text-24" [ngClass]="[white() ? 'text-white' : 'text-grey-400', '']"></i>
</span>
